import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import info from './info'
import category from './category'
import record from './record'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        error: null
    },
    mutations: {
        setError(state, error) {
            state.error = error
        },
        clearError(state) {
            state.error = null
        }
    },
    actions: {
        async fetchCurrency() {
            const res = await fetch(`https://prime.exchangerate-api.com/v5/738720fdf88812432871b16c/latest/USD`) 
            return await res.json()
            // https://api.exchangeratesapi.io/latest?symbols=USD,RUB
        }
    },
    getters: {
        error: s => s.error
    },
    modules: {
        auth,
        info,
        category,
        record
    }
})
